<template>
    <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asd</span></td>
                            <td class="text-right text-white font-weight-bold b-right">31 December 2020</td>
                            <td class="text-right text-white font-weight-bold ">31 December 2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asd</span></td>
                            <td class="text-left text-white font-weight-bold">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Credit quality – Performing</td>
                            <td class="text-right">107,435</td>
                            <td class="text-right">85,874</td>
                        </tr>
                        <tr>
                            <td>Impaired</td>
                            <td class="text-right">8,543</td>
                            <td class="text-right">7,171</td>
                        </tr>
                        <tr>
                            <td>ECL</td>
                            <td class="text-right">(9,546)</td>
                            <td class="text-right">(10,739)</td>
                        </tr>
                        <tr>
                            <td><span class="invisible">asd</span></td>
                            <td class="text-right">106,432</td>
                            <td class="text-right">82,306</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asd</span></td>
                            <td class="text-right text-white font-weight-bold b-right">31 ديسمبر 2020</td>
                            <td class="text-right text-white font-weight-bold ">31 ديسمبر 2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asd</span></td>
                            <td class="text-left text-white font-weight-bold">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>الجدارة الائتمانية – منتظمة</td>
                            <td class="text-right">107,435</td>
                            <td class="text-right">85,874</td>
                        </tr>
                        <tr>
                            <td>منخفضة القيمة</td>
                            <td class="text-right">8,543</td>
                            <td class="text-right">7,171</td>
                        </tr>
                        <tr>
                            <td>الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">(9,546)</td>
                            <td class="text-right">(10,739)</td>
                        </tr>
                        <tr>
                            <td><span class="invisible">asd</span></td>
                            <td class="text-right">106,432</td>
                            <td class="text-right">82,306</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>